import React, { useState } from "react";
import { DashboardCard } from "../card";
import { Responsive, WidthProvider } from "react-grid-layout";
import PropTypes from "prop-types";
import { DASHBOARD_ITEM_TYPE } from "../constants";

// use from here because this is HOC
const ResponsiveReactGridLayout = WidthProvider(Responsive);

export const DashboardDisplayPage = (props) => {
  const { currentVessel, selectedDashboard, elRef } = props;
  const defaultProps = {
    className: "layout",
    rowHeight: 30,
    cols: { lg: 36, md: 24, sm: 18, xs: 12, xxs: 6 },
    breakpoints: { lg: 1200, md: 996, sm: 768, xs: 480, xxs: 0 },
    static: true,
    isDraggable: false,
    isResizable: false,
  };
  const [state, setState] = useState({
    currentBreakpoint: "lg",
    compactType: "vertical",
    mounted: false,
    layouts: {},
  });

  // for hide resize icon and icon
  const resizeHandle = (resizeHandleAxis, ref) => {
    if (!defaultProps.isResizable) {
      // do not return null here, or it throws error
      return <span className="hidden" />;
    }
    // this is the same as original
    return (
      <span
        ref={ref}
        className={`react-resizable-handle react-resizable-handle-${resizeHandleAxis}`}
      />
    );
  };

  const onLayoutChange = (layout, layouts) => {
    setState((current) => ({ ...current, layouts }));
  };

  return (
    <div
      style={{
        userSelect: "none",
        MozUserSelect: "none",
        WebkitUserSelect: "none",
        background: "#252d3980 50%",
        minWidth: "1500px",
      }}
      ref={elRef}
    >
      <ResponsiveReactGridLayout
        resizeHandle={resizeHandle}
        onLayoutChange={onLayoutChange}
        {...defaultProps}
        className="layout"
        layouts={state.layouts}
        measureBeforeMount={false}
        compactType={state.compactType}
        style={{
          "& > .reactGridItem > .reactResizableHandle.reactResizableHandleSe::after": {
            opacity: "0 !important",
          },
        }}
      >
        {selectedDashboard?.items?.filter(i => i.type !== DASHBOARD_ITEM_TYPE.LABEL)?.map((el, index) => {
          return (
            <div key={el.id} data-grid={{ ...el.position }}>
              <DashboardCard
                vessel={currentVessel}
                dashboard={selectedDashboard}
                item={el}
                index={index}
                isEdit={false}
              />
            </div>
          );
        })}
      </ResponsiveReactGridLayout>
    </div>
  );
};

DashboardDisplayPage.propTypes = {
  currentVessel: PropTypes.object,
  selectedDashboard: PropTypes.object,
  elRef: PropTypes.object,
};
